/**
 * Copyright © 2026 Adnuntius AS.
 */
import * as _ from 'lodash';

export const REPORT_TRANSLATION_LANGUAGES = ['EN', 'DE', 'FR'] as const;

export interface ReportTranslationOverride {
  id: string;
  defaultTranslation: string;
  translation: string;
  edited: boolean;
}

export type ReportTranslationOverrideMap = Record<string, Record<string, ReportTranslationOverride>>;

export function initReportTranslationModel(model: any): void {
  model.locale = model.locale || 'en';
  model.defaultTranslation = model.defaultTranslation || 'EN';
}

export function buildReportTranslationOverrides(
  model: any,
  transDefaults: Record<string, Record<string, string>>
): ReportTranslationOverrideMap {
  const translations: ReportTranslationOverrideMap = {};
  _.forEach(transDefaults, (defaultsForLang, langKey) => {
    translations[langKey] = {};
    _.forEach(defaultsForLang, (defaultVal, transKey) => {
      const translationValue = _.get(model, ['translations', transKey]);
      const isBaseLang = model.defaultTranslation.toLowerCase() === langKey;
      translations[langKey][transKey] = {
        id: transKey,
        defaultTranslation: defaultVal,
        translation: isBaseLang ? (translationValue || defaultVal) : defaultVal,
        edited: isBaseLang && !!translationValue && translationValue !== defaultVal
      };
    });
  });
  return translations;
}

export function getActiveReportTranslationOverrides(
  translations: ReportTranslationOverrideMap,
  defaultTranslation: string
): ReportTranslationOverride[] {
  const langKey = (defaultTranslation || 'EN').toLowerCase();
  return translations[langKey] ? Object.values(translations[langKey]) : [];
}

export function prepareReportTranslationForSubmit(
  model: any,
  translations: ReportTranslationOverrideMap
): void {
  model.translations = {};
  const langKey = model.defaultTranslation.toLowerCase();
  _.forEach(translations[langKey], (val) => {
    if (val.edited && val.translation && val.translation !== val.defaultTranslation) {
      model.translations[val.id] = val.translation;
    }
  });
}
